import { Layouts } from "../../constants/Constants";

export function isHolMol(membershipNumber, layout) {
  if (
    membershipNumber &&
    membershipNumber.search("HOL") === 0 &&
    layout === Layouts.MOL
  ) {
    return true;
  }
  return false;
}
